<template>
    <div class="z-logo">
        <template v-if="isIndex">
            <img :src="buildSrc" class="z-logo__img" :alt="title">
        </template>
        <template v-else>
            <a :href="siteDir" class="z-logo__link" :title="title">
                <img :src="buildSrc" class="z-logo__img" :alt="title">
            </a>
        </template>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'z-logo',
    props: {
        isIndex: {
            type: Boolean
        },
        siteDir: {
            type: String,
            required: true
        },
        invert: Boolean,
        lang: {
            type: String
        }
    },
    data () {
        return {
            title: localize({
                ru: 'Торговая компания МС Трейд',
                en: 'MS Trade Trading Company'
            })
        }
    },
    computed: {
        menuInvert () {
            return this.$store.getters.menuInvert
        },
        menuOpen () {
            return this.$store.getters.menuOpen
        },
        buildSrc () {
            let lang = this.lang.replace(/\//g, '')

            if (this.invert || this.menuInvert) {
                if (this.menuOpen) return require(`./images/logo--${lang}.svg`)
                return require(`./images/logo-invert--${lang}.svg`)
            }

            return require(`./images/logo--${lang}.svg`)
        }
    }
}
</script>

<style lang="scss">
.z-logo {
    img {
        display: block;
        width: 100%;
        user-select: none;
    }

    &__link {
        display: block;
    }
}
</style>
